import _ from "underscore";
import Backbone from "backbone";

const AssetModel = Backbone.Model.extend({
    initialize(options) {
        this.personId = options.personId;
        this.assetId = options.assetId;
    },

    url() {
        return `/api/v2/persons/${this.personId}/assets/${this.assetId}`;
    },
});
export default AssetModel;
